<div class="pdf-page app-aul-028-24" id="aul02824">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b> SICK BUILDING CONDITION(S) EXCLUSION </b>
  </p>

  <p class="font-medium">
    <b> THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
  </p>
  <br />
  <p class="font-small">
    This endorsement modifies insurance provided under the following forms.
    <br />
    CAUSES OF LOSS - SPECIAL FORM
  </p>
  <br />
  <p class="font-small">
    The following <b>Sick Building Condition(s) Exclusion</b> is added to this
    policy:
  </p>
  <p class="font-small"><b>Sick Building Condition(s) Exclusion</b></p>
  <p class="font-small">
    We will not pay for loss, damage or expense, or increase in loss, damage or
    expense caused by or resulting directly or indirectly from
    <b>Sick Building Condition(s)</b>.
  </p>
  <p class="font-small">
    For the purpose of this exclusion, Sick Building Condition(s) shall mean a
    building(s) or structure(s) with actual or alleged conditions, either
    created or resulting from ventilation, heating, air conditioning or
    otherwise, which may create an environment which is, or is suspected to be,
    unhealthy in any way to any person or other living thing.
  </p>

  <p class="font-small">
    <b>All other terms and conditions of this policy remain unchanged.</b>
  </p>
</div>
